import * as Actions from './listing.actions';
import { ListingState, ListingAction } from './listing.actions';
import { REQUEST_SUCCESS, REQUEST_FAILED, REQUEST_IN_PROGRESS, REQUEST_UNTOUCHED } from '../../../../types/request-state.model';
import { Action } from 'rxjs/internal/scheduler/Action';

const initialState: ListingState = {

}

export default function Listing(state: ListingState = initialState, action: ListingAction) {
  switch (action.type) {

    case Actions.REFRESH_LISTING:
      return Object.assign({}, state, action.payload, {
        refreshListingStatus: REQUEST_IN_PROGRESS
      } as ListingState)

    case Actions.REFRESH_LISTING_FAIL:
      return Object.assign({}, state, action.payload, {
        refreshListingStatus: REQUEST_FAILED
      } as ListingState)

    case Actions.REFRESH_LISTING_SUCCESS:
      return Object.assign({}, state, action.payload, {
        refreshListingStatus: REQUEST_SUCCESS
      } as ListingState)

          // delete listing
    case Actions.DELETE_LISING:
      return Object.assign({}, state, action.payload, {
        deletePropertyStatus: REQUEST_IN_PROGRESS
      } as ListingState)

    case Actions.DELETE_LISTING_FAIL:
      return Object.assign({}, state, action.payload, {
        deletePropertyStatus: REQUEST_FAILED
      } as ListingState)

    case Actions.DELETE_LISTING_SUCCESS:
      return Object.assign({}, state, action.payload, {
        deletePropertyStatus: REQUEST_SUCCESS
      } as ListingState)

      
    case Actions.EXPIRE_LISTING:
      return Object.assign({}, state, action.payload, {
        expireListingStatus: REQUEST_IN_PROGRESS
      } as ListingState)

    case Actions.EXPIRE_LISTING_SUCCESS:
      return Object.assign({}, state, action.payload, {
        expireListingStatus: REQUEST_SUCCESS
      } as ListingState)
    
    case Actions.EXPIRE_LISTING_FAIL:
      return Object.assign({}, state, action.payload, {
        expireListingStatus: REQUEST_FAILED
      } as ListingState)

    case Actions.GET_LISTING_DATA:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getListingDataState: REQUEST_IN_PROGRESS,
          listings: null,
          totalListings: null
        } as ListingState
      );

    case Actions.GET_LISTING_DATA_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getListingDataState: REQUEST_SUCCESS
        } as ListingState
      );

    case Actions.GET_LISTING_DATA_FAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getListingDataState: REQUEST_FAILED
        } as ListingState
      );

    case Actions.GET_LISTING_DETAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getListingDetailState: REQUEST_IN_PROGRESS
        } as ListingState
      );

    case Actions.GET_LISTING_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getListingDetailState: REQUEST_SUCCESS
        } as ListingState
      );

    case Actions.GET_LISTING_DETAIL_FAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getListingDetailState: REQUEST_FAILED
        } as ListingState
      );

    case Actions.POST_PROPERTY:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          submitPropertyStatus: REQUEST_IN_PROGRESS
        } as ListingState
      );

    case Actions.POST_PROPERTY_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          submitPropertyStatus: REQUEST_SUCCESS
        } as ListingState
      );

    case Actions.POST_PROPERTY_FAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          submitPropertyStatus: REQUEST_FAILED
        } as ListingState
      );

    case Actions.SAVE_AS_DRAFT:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          submitDraftStatus: REQUEST_IN_PROGRESS
        } as ListingState
      );

    case Actions.SAVE_AS_DRAFT_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          submitDraftStatus: REQUEST_SUCCESS
        } as ListingState
      );

    case Actions.SAVE_AS_DRAFT_FAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          submitDraftStatus: REQUEST_FAILED
        } as ListingState
      );

    case Actions.GENERATE_DESCRIPTION_PREFILL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          retrieveDescPrefillStatus: REQUEST_IN_PROGRESS
        } as ListingState
      );

    case Actions.GENERATE_DESCRIPTION_PREFILL_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          retrieveDescPrefillStatus: REQUEST_SUCCESS
        } as ListingState
      );

    case Actions.GENERATE_DESCRIPTION_PREFILL_FAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          retrieveDescPrefillStatus: REQUEST_FAILED
        } as ListingState
      );

    case Actions.UPDATE_PROPERTY:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          updatePropertyStatus: REQUEST_IN_PROGRESS
        } as ListingState
      );

    case Actions.UPDATE_PROPERTY_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          updatePropertyStatus: REQUEST_SUCCESS
        } as ListingState
      );

    case Actions.UPDATE_PROPERTY_FAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          updatePropertyStatus: REQUEST_FAILED
        } as ListingState
      );

    case Actions.CLEAR_FOCUSED_LISTING:
      return Object.assign(
        {},
        state,
        {
          focusedListing: null,
          focusedPropertyKey: '',
          getListingDetailState: REQUEST_UNTOUCHED
        } as ListingState
      )

    case Actions.RESET_POST_PROPERTY:
      return Object.assign(
        {},
        state,
        {
          apiProperty: null,
          descriptionPrefill: null,
          submitPropertyStatus: REQUEST_UNTOUCHED,
          submitDraftStatus: REQUEST_UNTOUCHED,
          retrieveDescPrefillStatus: REQUEST_UNTOUCHED
        } as ListingState
      )

      case Actions.UPDATE_PROPERTY_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          updatePropertyStatus: REQUEST_SUCCESS
        } as ListingState
      );

    case Actions.UPDATE_PROPERTY_FAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          updatePropertyStatus: REQUEST_FAILED
        } as ListingState
      );

    case Actions.CLEAR_FOCUSED_LISTING:
      return Object.assign(
        {},
        state,
        {
          focusedListing: null
        } as ListingState
      );

    case Actions.GET_API_PROPERTY:
      return Object.assign(
        {},
        state,
        action.payload
      );

    case Actions.GET_API_PROPERTY_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload
      );

    case Actions.GET_API_PROPERTY_FAIL:
      return Object.assign(
        {},
        state
      );

    default:
      return state;
  }
}